<template>
  <div v-if="items.length === 0" class="pt-links__empty">
暂无数据
  </div>
  <!-- 资讯链接列表：支持日期、热点高亮、双列、纵向撑满(fill) -->
  <ul
    v-else
    class="pt-links"
    :class="[{ 'pt-links--2col': columns === 2, 'is-fill': fill }]"
  >
    <li v-for="(item, i) in items" :key="i" class="pt-links__item">
      <a class="pt-links__link" :class="{ 'is-hot': item.hot }" @click="$emit('item-click', item)">
        <span class="pt-links__dot" />
        <span class="pt-links__title">{{ item.title }}</span>
        <span v-if="item.hot" class="pt-links__hot">热</span>
        <time v-if="item.date && !hideDate" class="pt-links__date">{{ item.date }}</time>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'LinkList',
  props: {
    items: { type: Array, default: function () { return [] } },
    columns: { type: Number, default: 1 },
    fill: { type: Boolean, default: false },
    hideDate: { type: Boolean, default: false }
  }
}
</script>

<style lang="less" scoped>
.pt-links {
  margin: 0;
  padding: 0;
  list-style: none;
}

/* fill：纵向平铺撑满卡片高度（用于 Banner 右侧「最新资讯」） */
.pt-links.is-fill {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  height: 100%;
}
.pt-links.is-fill .pt-links__item {
  flex: 0 0 20%;
}
.pt-links.is-fill .pt-links__link {
  height: 100%;
}

/* 双列 */
.pt-links--2col {
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 20px;
  grid-auto-rows: 50px;
}
@media (min-width: 640px) {
  .pt-links--2col {
    grid-template-columns: 1fr 1fr;
  }
}
.pt-links--2col.is-fill {
  grid-auto-rows: 50px;
}
.pt-links--2col .pt-links__item {
  min-width: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.pt-links--2col .pt-links__link {
  width: 100%;
}
.pt-links--2col .pt-links__title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pt-links__item {
  border-bottom: 1px dashed var(--pt-line-2, #e5e7eb);
}
.pt-links__item:last-child {
  border-bottom: 0;
}

.pt-links__link {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 0;
  color: var(--pt-ink-soft, #374151);
  font-size: 14px;
  cursor: pointer;
}
.pt-links__link:hover {
  color: var(--pt-brand, #1e63b0);
}
.pt-links__link:hover .pt-links__title {
  text-decoration: underline;
}

.pt-links__dot {
  flex: none;
  width: 5px;
  height: 5px;
  border-radius: 999px;
  background: #c9ced6;
  transition: background 0.2s;
}
.pt-links__link:hover .pt-links__dot {
  background: var(--pt-brand, #1e63b0);
}

.pt-links__title {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pt-links__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  color: var(--pt-muted, #9ca3af);
  font-size: 13px;
}
.pt-links__date {
  flex: none;
  margin-left: auto;
  font-size: 12px;
  color: var(--pt-muted, #9ca3af);
}

/* 热点高亮 */
.pt-links__link.is-hot {
  color: var(--pt-brand, #1e63b0);
  font-weight: 600;
}
.pt-links__link.is-hot .pt-links__dot {
  background: #e4393c;
}
.pt-links__hot {
  flex: none;
  padding: 2px 4px;
  border-radius: 3px;
  background: #e4393c;
  color: #fff;
  font-size: 11px;
  font-weight: 400;
  line-height: 1;
}

</style>
